import cn from 'classnames';
import styles from './skeleton.module.scss';

type SkeletonProps = {
  height?: string;
  width?: string;
  className?: string;
  suppressInlineStyle?: boolean;
};

// For images (className can be used to determine size)
export const SkeletonImage = ({ className = styles.skeletonImage }: SkeletonProps) => <div className={cn(className, 'skeleton')} />;

// Can be used for titles, content & buttons
export const SkeletonBlock = ({ className = 'marginBottom-small', height = '48', width = '100', suppressInlineStyle = false }: SkeletonProps) => {
  const inlineStyles = !suppressInlineStyle
    ? {
        height: `${height}px`,
        width: `${width}%`,
      }
    : {};

  return <div className={cn(className, 'skeleton border-radius medium')} style={inlineStyles} />;
};

/*
  Usage:
  import SkeletonPage from '@components/Loaders/Skeleton/Skeleton.sku';

  <SkeletonPage />

  Dev Notes:
  This is a first pass at it. We can cleanup as we go.
  .skeleton & border-radius are classes that I added to global typography.
*/
